import React from 'react'
import {SidebarContainer,Icon,CloseIcon,SidebarWrapper
,SidebarMenu,SideBtnWrap,SidebarLink,SidebarRoute} from './SidebarElement'
const Sidebar = ({isOpen,toggle}) => {
    return (
        <div>
            <SidebarContainer isOpen={isOpen} onClick={toggle}>
                <Icon onClick={toggle}>
                    <CloseIcon/>
                </Icon>
                <SidebarWrapper>
                    <SidebarMenu>
                        <SidebarLink to="home">Home</SidebarLink>
                        <SidebarLink to="about">About</SidebarLink>
                        <SidebarLink to="skill">Advance</SidebarLink>
                        <SidebarLink to="porto">Portofilio</SidebarLink>
                    </SidebarMenu>
                </SidebarWrapper>
                <SideBtnWrap>
                    <SidebarRoute to="contact">Contact Us</SidebarRoute>
                </SideBtnWrap>
            </SidebarContainer>
        </div>
    )
}

export default Sidebar
